<template>
  <el-container class="doc-container">
    <el-header class="doc-header">
      <div class="header-content">
        <div class="logo">
          <img src="../../assets/img/logo_icon.png" alt @click="toHome" />
          <span>来布科技API文档</span>
        </div>
      </div>
    </el-header>
    <el-container class="doc-main-container">
      <!-- 左侧树 -->
      <el-aside width="300px" class="doc-aside">
        <el-tree :data="treeData" :props="defaultProps" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
      </el-aside>
      <el-main class="doc-main">
        <div class="main-wrap">
          <!-- 面包屑 -->
          <el-breadcrumb separator="/" class="doc-breadcrumb" v-if="currSelectNode?.id">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">{{ item.name }}</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- 文章内容 -->
          <div class="document-wrap">
            <PDF v-if="currSelectNode?.src" :pdfSrc="currSelectNode?.src" />
            <!-- <iframe
              v-if="currSelectNode?.id == 1"
              src="/api/ShuAnYiCustomizationAPI.htm"
              width="100%"
              height="100%"
              sandbox="allow-scripts"
              style="display: block; border: none"
            ></iframe> -->
            <!-- <GaiShu v-else-if="currSelectNode?.id == 3" />
            <iframe
              v-else-if="currSelectNode?.id == 4"
              src="http://www.iclabs.cn/religion.pdf"
              width="100%"
              height="100%"
            ></iframe>
            <iframe
              v-else-if="currSelectNode?.id == 5"
              src="/api/ShuAnYiCustomizationAPI.htm"
              width="100%"
              height="100%"
            ></iframe> -->
            <!-- <div
              v-else-if="currSelectNode?.id == 6"
              v-html="agreementContent"
            ></div> -->
            <el-empty v-else description=" "></el-empty>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// import GaiShu from "./components/GaiShu.vue";
import PDF from "../../components/Pdf.vue";

export default {
  components: { PDF },
  data() {
    return {
      treeData: [
        {
          label: "数安易定制化API",
          id: 1,
          src: "/api/数安易定制化API.pdf",
          breadcrumb: "数安易定制化API",
        },
        // {
        //   label: "日志SDK",
        //   children: [
        //     {
        //       label: "文件维度读取日志接口",
        //       id: 2,
        //       breadcrumb: "日志SDK / 文件维度读取日志接口",
        //     },
        //     {
        //       label: "用户维度读取日志接口",
        //       id: 3,
        //       breadcrumb: "日志SDK / 用户维度读取日志接口",
        //     },
        //     {
        //       label: "接口参数与数安易对接参考",
        //       id: 4,
        //       breadcrumb: "日志SDK / 接口参数与数安易对接参考",
        //     },
        //     {
        //       label: "测试",
        //       children: [
        //         {
        //           label: "概述",
        //           id: 5,
        //           breadcrumb: "日志SDK / 测试 / 概述",
        //         },
        //         {
        //           label: "PDF页面预览",
        //           id: 6,
        //           breadcrumb: "日志SDK / 测试 / PDF页面预览",
        //         },
        //         {
        //           label: "HTML页面预览",
        //           id: 7,
        //           breadcrumb: "日志SDK / 测试 / HTML页面预览",
        //         },
        //         {
        //           label: "无数据页面",
        //           id: 8,
        //           breadcrumb: "日志SDK / 测试 / 无数据页面",
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
      defaultProps: {
        children: "children",
        label: "label",
        id: "id",
      },
      currSelectNode: null,
      breadcrumbList: [{ id: 0, name: "首页" }],
      agreementContent: "",
    };
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      this.currSelectNode = data;
      if (data.id == this.breadcrumbList[this.breadcrumbList.length - 1].id) {
        return;
      }
      this.breadcrumbList.pop();
      this.breadcrumbList.push({ id: data?.id, name: data?.breadcrumb });
    },
    toHome() {
      this.$router.replace("/");
    },
  },
  mounted() {
    if (this.treeData.length > 0) {
      this.currSelectNode = this.treeData[0];
      this.breadcrumbList.push({
        id: this.treeData[0]?.id,
        name: this.treeData[0]?.breadcrumb,
      });
    }

    // 使用 fetch 或 axios 请求加载 .htm 文件内容
    // fetch("/api/ShuAnYiCustomizationAPI.htm")
    //   .then((response) => response.text())
    //   .then((data) => {
    //     this.agreementContent = data;
    //     console.log("this.agreementContent", this.agreementContent);
    //   })
    //   .catch((error) => {
    //     console.error("Failed to load the agreement file:", error);
    //   });
  },
};
</script>
<style lang="scss" scoped>
body {
  display: isolate;
}
* {
  padding: 0;
  margin: 0;
  user-select: text !important;
  box-sizing: border-box;
}
.doc-container {
  height: 100vh;
  overflow: hidden;
  user-select: text !important;
}
.el-header {
  height: 60px !important;
  position: static;
}
.doc-header {
  border-bottom: 1px solid #e8ebec;
  .header-content {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 0 !important;
    .logo {
      display: flex;
      align-items: center;
      width: auto;
      margin: 0;
      font-size: 25px;
      font-weight: 500;
      color: #292929;
      img {
        width: 35px;
        margin-right: 10px;
      }
    }
  }
}
.doc-main-container {
  height: calc(100vh - 60px);
}
.doc-aside {
  border-right: 1px solid #e8ebec;
  height: calc(100vh - 60px);
  padding: 20px 0;
  overflow: hidden;
  overflow-y: scroll;
}
.el-main {
  margin: 0;
}
.doc-main {
  height: calc(100vh - 60px);
  overflow: hidden;
  overflow-y: scroll;
  padding: 16px 32px 8px !important;
  display: flex;
  justify-content: center;
  min-height: auto;
  .main-wrap {
    width: 932px;
    display: flex;
    flex-direction: column;
  }
  .doc-breadcrumb {
    height: 22px;
  }
  .document-wrap {
    margin-top: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    overflow-y: scroll;
    .el-empty {
      height: 100%;
    }
  }
}
// .el-tree-node__content {
//   height: 30px;
// }
</style>
